import PropTypes from 'prop-types';
import React from 'react';
import { useDropzone } from 'react-dropzone';

import Button from 'components/atomic/Button';

const UploadButton = ({ accept, renderAs, onChange, ...restProps }) => {
  const onDrop = (acceptedFiles) => {
    onChange && onChange(acceptedFiles[0]);
  };

  const { getRootProps, getInputProps, open } = useDropzone({ onDrop, accept, noClick: true, noDrag: true });

  const Component = renderAs || Button;

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <Component {...restProps} onClick={open} />
    </div>
  );
};

UploadButton.propTypes = {
  renderAs: PropTypes.func,
  accept: PropTypes.string,
  onChange: PropTypes.func,
};

export default UploadButton;
